/**
 * Screens that belong to a module the platform can switch off per org (API:
 * core/modules.ts). A screen not listed here is core: every org has it. Keyed
 * by the first segment of the screen's path.
 */
export const SCREEN_MODULE: Record<string, string> = {
  '/inbound': 'inbound',
  '/quality': 'quality',
  '/coaching': 'coaching',
  '/wfm': 'wfm',
  '/scripts': 'scripts',
  '/outlets': 'sales', '/orders': 'sales', '/catalog': 'sales', '/territories': 'sales',
  '/picklists': 'sales', '/fields': 'sales', '/import-export': 'sales',
  '/whatsapp': 'whatsapp',
  '/sms': 'sms',
  '/assistant': 'ai',
}

/** The module of a screen path (its first segment), or null for the core. */
export const moduleOfPath = (path: string): string | null =>
  SCREEN_MODULE[`/${path.split('/')[1] ?? ''}`] ?? null
